import React, { Component } from 'react';

import uuid from 'uuid';
import memoizeOne from 'memoize-one';
import cx from 'classnames';
import Popover from 'react-popover';

import {
  BTN_CONTAINER,
  POPUP_CONTAINER } from
'../styles/actionPopup';
import '../styles/_action-popup.scss';

import { SUBMENU_WIDTH } from '../constants/submenuWidth';
import ActionItem from './ActionItem';
import Button from '../../Button';


















function removeSeparatorIfNeeded(options) {
  if (!options.length) {
    return options;
  }

  const lastOption = options[options.length - 1];
  const shouldRemoveSeparator = Boolean(
    Object.keys(lastOption).length === 1 && lastOption.separator
  );

  return shouldRemoveSeparator ?
  removeSeparatorIfNeeded(options.slice(0, -1)) :
  options;
}

class ActionPopup extends Component {


  withNoEventPropagation = memoizeOne((fn) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    fn(e);
  });

  constructor(props) {
    super(props);
    this.state = {
      popoverIsOpen: false,
      preferredPosition: 'right',
      place: 'column',
      distanceToRightEdge: 0
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    this.setState({ distanceToRightEdge: this.getDistanceToRightEdge() });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => this.setState({ distanceToRightEdge: this.getDistanceToRightEdge() });

  getDistanceToRightEdge = () => {
    if (!this._actionPopupRef) {return 0;}

    const boundingRect = this._actionPopupRef.getBoundingClientRect();

    if (boundingRect === undefined) {return 0;}

    const { right } = boundingRect;

    return window.innerWidth - right;
  };

  togglePopover = () => {
    const { popoverIsOpen } = this.state;
    const { onClose, castDisableMenuButton } = this.props;

    if (castDisableMenuButton) {
      this.setState({ popoverIsOpen: false });
      return;
    }

    this.setState({ popoverIsOpen: !popoverIsOpen }, () => {
      const { popoverIsOpen: latestOpenState } = this.state;

      if (!latestOpenState && onClose) {
        // Wait for animation transition
        setTimeout(onClose, 500);
      }
    });
  };

  isRenderOnLeft = () => {
    const { distanceToRightEdge } = this.state;

    return distanceToRightEdge < SUBMENU_WIDTH;
  };

  renderItemSubMenu = (subMenu) =>
  <div className={cx('action-item__submenu-content', POPUP_CONTAINER)}>
      {subMenu.map((subOption) => this.renderMenuItem(subOption))}
    </div>;


  renderMenuItem = (option) =>
  <ActionItem
    key={uuid.v4()}
    hidePopover={option.keepOpen ? void 0 : this.togglePopover}
    action={option.action}
    label={option.label}
    isRed={option.isRed}
    separator={option.separator}
    prefixIconText={option.prefixIconText}
    hasSubmenu={Boolean(option.submenu)}
    className={cx(
      option.className || '',
      option.submenu ? cx(
        'action-item__submenu',
        { 'action-item__submenu-left': this.isRenderOnLeft() }
      ) : ''
    )}>

      {option.submenu && this.renderItemSubMenu(option.submenu)}
      {option.children &&
    <div className="no-hover">
          {option.children}
        </div>}

    </ActionItem>;


  renderBody = () => {
    const { options } = this.props;
    const updatedOptions = removeSeparatorIfNeeded(options);

    return updatedOptions.map((option) => this.renderMenuItem(option));
  };

  setActionPopupRef = (ref) => {
    if (!ref) {return;}

    this._actionPopupRef = ref;
  };

  render() {
    const {
      popupBtn,
      children,
      actionPopupConfig = {},
      castDisableMenuButton,
      className
    } = this.props;
    const { popoverIsOpen, preferredPosition, place } = this.state;

    const targetProps = {
      className: cx('action-menu', 'target', { 'is-closed': !popoverIsOpen, 'is-open': popoverIsOpen })
    };

    const targetToggleProps = {
      className: cx('action-menu__btn-container', BTN_CONTAINER),
      onClick: this.withNoEventPropagation(this.togglePopover)
    };

    const disable = castDisableMenuButton === true;

    const target =
    <div {...targetProps}>
        <div {...targetToggleProps}>
          {popupBtn || <Button type="TERTIARY" prefix="options" prefixSize={20} disabled={disable} />}
        </div>
      </div>;


    const popoverProps = {
      isOpen: popoverIsOpen,
      preferPlace: preferredPosition,
      place,
      onOuterAction: this.withNoEventPropagation(this.togglePopover),
      body: children || this.renderBody(),
      className: cx('action-popup__container', POPUP_CONTAINER, className),
      tipSize: 0.01,
      enterExitTransitionDurationMs: 0,
      ...actionPopupConfig
    };

    return (
      <div className="site-nav" ref={this.setActionPopupRef}>
        <Popover {...popoverProps}>{target}</Popover>
      </div>);

  }
}

export default ActionPopup;